import {Message} from "element-ui";
/**
 *
 *  查询线上/线下就诊记录的混合文件
 *
 * */

export const OnlineMixin = {
    data(){
      return {
          lineList:[], // 线下就诊记录
          onLineList:[], // 线上就诊记录
          totalList:[] //总的就诊记录
      }
    },
    methods:{
        //查询线下就诊记录
        async queryLineOrder(data){
            const {code,list,msg} = await this.$http('smarthos.yygh.apiOrderService.getLineOrder',{
                orgid:data.yyid,//yyid
                hzid:data.hzid, //hzid
                visitid:data.jzrid //jzrid
            })
            if(code == 0){
                this.lineList = list.map( (r,index) => {
                    r.key = `line-${index}`;
                    r.type = 'line';
                    let formatTime = r.visittime.replace(/-/g,'/');
                    r.modifyTime = new Date(formatTime).getTime();
                    return r
                });
                this.totalList = this.totalList.concat(this.lineList);
                this.totalList.sort( (a,b) => {
                    return b.modifyTime - a.modifyTime
                })

            }else{
                this.alertError(msg);
            }
        },
        //查询线上就诊记录
        async queryOnLineOrder(data){
            const {code,list,msg} = await this.$http('smarthos.online.outpatient.compat.list',{
                patId:data.hzid, //'132250562560', //hzid
                compatId:data.jzrid //'132250562561' //jzrid
            })
            if(code == 0){
                this.onLineList = list.map( (r,index) => {
                    r.key = `online-${index}`;
                    r.type = 'online';
                    return r
                });
                this.totalList = this.totalList.concat(this.onLineList);
                this.totalList.sort( (a,b) => {
                    return b.modifyTime - a.modifyTime
                })

            }else{
                this.alertError(msg);
            }
        },
        alertError(msg){
            Message({
                showClose: true,
                message: msg,
                type: "warning"
            });
        }
    }
}